import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

export const grey = {
  0: '#FFFFFF',
  100: '#F4F6F5',
  200: '#E9ECEB',
  300: '#CDD3D5',
  400: '#A9B2B6',
  500: '#7C898F',
  600: '#59666D',
  700: '#3D484E',
  800: '#252E33',
  900: '#171D21',
};

export const primary = {
  lighter: '#DCE8EC',
  light: '#7296A5',
  main: '#315E73',
  dark: '#244858',
  darker: '#17313D',
  contrastText: '#FFFFFF',
};
export const secondary = {
  lighter: '#FBE8CE',
  light: '#F0AE57',
  main: '#E58A22',
  dark: '#B86512',
  darker: '#713B0C',
  contrastText: '#FFFFFF',
};

// export const secondary = {
//   lighter: '#EFD6FF',
//   light: '#C684FF',
//   main: '#8E33FF',
//   dark: '#5119B7',
//   darker: '#27097A',
//   contrastText: '#FFFFFF',
// };

export const info = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#C8FAD6',
  light: '#5BE49B',
  main: '#00A76F',
  dark: '#007867',
  darker: '#004B50',
  contrastText: '#FFFFFF',
};

export const warning = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: grey[800],
};

export const error = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
};

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  divider: alpha(grey[500], 0.2),
  action,
};

// ----------------------------------------------------------------------

export function palette(mode = 'light', color = 'primary') {
  if (mode === 'light') {
    return {
      ...base,
      mode: 'light',
      text: {
        primary: grey[800],
        secondary: grey[600],
        disabled: grey[500],
      },
      background: {
        paper: '#FFFFFF',
        default: '#F2F4F3',
        neutral: grey[200],
      },
      action: {
        ...base.action,
        active: grey[600],
      },
    };
  }

  return {
    ...base,
    mode: 'dark',
    text: {
      primary: grey[0],
      secondary: grey[100],
      disabled: grey[600],
    },
    background: {
      paper: '#252E33',
      default: '#171D21',
      neutral: '#303A40',
    },
    action: {
      ...base.action,
      active: grey[600],
    },
  };
}
